import { CallApi, handleJSONResponse } from './common';
import { Category } from '@common/types/categories/category';

const callAPI = CallApi('categories');

export const list = async (categoryType: string) => {
  const response = await callAPI(`/${ categoryType }`, 'GET');

  return await handleJSONResponse(response) as Category[];
}

export const genres = () => list('genre');
export const regions = () => list('region');
export const platforms = () => list('platform');